<template>
  <div class="profile-info">
    <!-- 个人简介部分 -->
    <section class="bio-section">
      <!-- 头像和名字区域 -->
      <div class="profile-header">
        <div class="avatar">
          <img :src="profile.avatar" alt="头像" />
        </div>
        <div class="name-container">
          <h1>{{ profile.name }}</h1>
          <p class="title">{{ profile.title }}</p>
        </div>
      </div>
      
      <!-- 个人简介 -->
      <div class="bio-text">
        <p>{{ profile.bio }}</p>
      </div>
      
      <!-- 社交媒体图标链接 -->
      <div class="social-links">
        <a 
          v-for="(link, index) in profile.links" 
          :key="index" 
          :href="link.url" 
          target="_blank"
          :title="link.name"
          class="social-icon"
        >
          <span class="icon" v-html="link.icon"></span>
        </a>
      </div>
    </section>
    
    <!-- 可展开菜单区域 -->
    <section class="menus-section">
      <details 
        v-for="(menu, index) in menus" 
        :key="index" 
        class="menu-item"
        :open="openedMenu === index"
      >
        <summary @click.prevent="toggleMenu(index)">
          <div class="summary-content">
            <span class="triangle"></span>
            <span class="menu-title">{{ menu.title }}</span>
          </div>
          <div class="line"></div>
        </summary>
        <!-- 使用@click.stop阻止点击事件冒泡，防止内容区域的点击导致菜单关闭 -->
        <div 
          class="menu-content markdown-body" 
          v-html="renderMarkdown(menu.content)"
          @click.stop
        ></div>
      </details>
    </section>

    <!-- 访问计数器 -->
    <section class="counter-section">
      <img src="https://count.getloli.com/@ganyu_personpage?name=ganyu_personpage&theme=moebooru&padding=7&offset=0&align=top&scale=1&pixelated=1&darkmode=auto" alt="访问计数器" />
    </section>

    <!-- 添加页脚 -->
    <footer class="profile-footer">
      <div class="footer-line"></div>
      <p class="copyright">© {{ currentYear }} Wang Xiaomei. All rights reserved.</p>
      <p class="slogan">由超快的 <a href="https://pages.cloudflare.com/">Cloudflare Pages</a> (中国大陆除外)提供支持</p>
    </footer>
  </div>
</template>

<script>
// 导入 markdown-it 库处理 Markdown
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
  typographer: true
});

export default {
  name: 'ProfileInfo',
  data() {
    return {
      // 追踪当前打开的菜单索引
      openedMenu: null,
      profile: {
        name: '王小美',
        title: '“我只希望在那一刻，回望生命中的无数段故事时，能够问心无愧地告诉自己，我不后悔自己曾做出的每一个选择。”',
        avatar: '/images/avatar.png', // 头像图片应放在 public/images 目录下
        bio: '我是王小美，曾用名g2nnyS。业余无线电台BD7PVQ，常驻广州，计算机/网络、轨道交通、航天、音游、CS2完美C+苦手。欢迎线下面基、通联、换卡。\n右侧的所有图片来自Pixiv，点击图片可前往作品原页面。\n更多信息请点击下方折叠菜单。\n GPG Public Key: 6283050A7224971C',
        links: [
          { 
            name: 'GitHub', 
            url: 'https://github.com/g2nnyS', 
            icon: '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>' 
          },
          { 
            name: '博客', 
            url: 'https://blog.ganyu.rocks', 
            icon: '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M14.8 3a2 2 0 0 0-1.4.6l-10 10a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0l10-10c.4-.4.6-.9.6-1.4V5a2 2 0 0 0-2-2h-5.2zM12 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>' 
          },
          { 
            name: 'Twitter', 
            url: 'https://twitter.com/_Genshin_Ganyu_', 
            icon: '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"/></svg>' 
          },
          { 
            name: 'Telegram', 
            url: 'https://t.me/Ganyu_Genshin', 
            icon: '<svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>' 
          }
        ]
      },
      menus: [
        {
          title: '换卡/业余无线电',
          content: `
我的业余无线电台呼号是 **BD7PVQ**
操作技术能力等级 **B**
DMR ID: 4611488
hamcq论坛用户名: BD7PVQ-Ganyu

甘雨已开始使用卡片局收寄，欢迎寄送QSL卡片、明信片。

**中文地址：**

上海市 399-5 邮政信箱 GANYU 021-58223996（收），邮编：201399

**English Address：**

GANYU P.O. Box 399-5, HuiNan Post Office, Shanghai 201399, P.R.China, +86-21-58223996
          `
        },
        {
          title: 'Github Status',
          content: `
![](https://github-readme-stats.vercel.app/api?username=g2nnyS&include_all_commits=true&bg_color=30,AFA2FF,F4AFB4&title_color=fff&text_color=fff)
          `
        },
        {
          title: '友情链接',
          content: `
- [Ra1n4 の 赛博小窝](https://ra1n4.ink/)
          `
        },
      ]
    };
  },
  computed: {
    // 自动获取当前年份
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    // 优化菜单切换方法，处理选择文本的情况
    toggleMenu(index) {
      // 如果点击已打开的菜单，则关闭它
      if (this.openedMenu === index) {
        this.openedMenu = null;
      } else {
        // 否则打开新的菜单（这会自动关闭之前打开的菜单）
        this.openedMenu = index;
      }
    },
    
    // Markdown渲染方法
    renderMarkdown(content) {
      return md.render(content);
    }
  }
}
</script>

<style scoped>
.profile-info {
  height: auto; /* 修改为自适应高度 */
  color: #e0e0e0;
  max-width: 85%; /* 缩小内容宽度 */
  width: 100%; /* 保证响应式 */
  margin: 0 auto; /* 水平居中 */
  padding: 0;
  text-align: left;
}

/* 移除个人简介的边框和背景 */
.bio-section {
  margin-bottom: 30px; /* 减小底部间隔 */
  padding-bottom: 15px; /* 减小内边距 */
  border-bottom: 1px solid #333;
}

/* 头像和名字布局 */
.profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px; /* 减小间隙 */
}

.avatar {
  flex-shrink: 0;
}

.avatar img {
  width: 70px; /* 缩小头像 */
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #444;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.avatar img:hover {
  transform: scale(1.05);
  border-color: #66d9ff;
}

.name-container {
  flex-grow: 1;
}

.name-container h1 {
  font-size: 1.6rem; /* 缩小字号 */
  margin: 0 0 5px 0;
  color: #ffffff;
}

.name-container .title {
  font-size: 0.95rem; /* 缩小字号 */
  color: #a9a9a9;
  margin: 0;
  font-style: italic;
}

/* 简介文本 */
.bio-text {
  white-space: pre-line; /* 添加此属性即可支持换行 */
  line-height: 1.5; /* 减小行高 */
  font-size: 0.9rem; /* 缩小字号 */
  margin-bottom: 20px;
}

/* 社交媒体图标 - 左对齐 */
.social-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* 减小间隙 */
  justify-content: flex-start;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px; /* 缩小图标 */
  height: 36px;
  background-color: #2a2a2a;
  color: #66d9ff;
  border-radius: 50%;
  transition: all 0.3s ease;
  border: 1px solid #444;
}

.social-icon:hover {
  background-color: #333;
  color: #1ad1ff;
  transform: translateY(-3px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

.social-icon .icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 菜单部分改进 */
.menu-item {
  margin-bottom: 15px; /* 减小间距 */
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.menu-item:hover {
  transform: translateY(-2px);
}

details {
  position: relative;
}

summary {
  padding: 15px 0;
  font-weight: bold;
  cursor: pointer;
  color: #e0e0e0;
  outline: none;
  display: flex;
  flex-direction: column;
  position: relative;
  list-style: none; /* 移除默认的三角形 */
  user-select: none; /* 防止选择summary文本 */
}

/* 去除默认的三角形 */
summary::-webkit-details-marker {
  display: none;
}

.summary-content {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* 自定义三角形 */
.triangle {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0 6px 8px;
  border-color: transparent transparent transparent #66d9ff;
  margin-right: 10px;
  transition: transform 0.3s ease;
}

/* 旋转三角形当展开时 */
details[open] .triangle {
  transform: rotate(90deg);
}

.menu-title {
  font-size: 1rem; /* 缩小字号 */
}

/* 水平线 */
.line {
  height: 1px;
  background: linear-gradient(to right, transparent, #444, #444, transparent);
  margin-top: 5px;
}

/* 打开的菜单内容样式 */
.menu-content {
  padding: 15px 0 5px 20px; /* 减小内边距 */
  line-height: 1.5; /* 减小行高 */
  font-size: 0.9rem; /* 缩小字体 */
  animation: fadeIn 0.3s ease;
  max-height: 500px; /* 合理的大值 */
  overflow: hidden;
  transition: max-height 0.3s ease;
  user-select: text; /* 确保内容区域可以选择文本 */
}

details:not([open]) .menu-content {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}

/* 当详情打开时调整布局 */
details[open] .menu-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 列表样式 */
.menu-content ul {
  list-style-position: inside;
  margin-left: 0;
  padding-left: 0;
}

.menu-content li {
  margin-bottom: 8px; /* 减少列表项间距 */
  padding-left: 10px;
}

.menu-content li::before {
  content: "•";
  color: #66d9ff;
  display: inline-block;
  width: 1em;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    text-align: center;
  }
  
  .social-links {
    justify-content: center;
  }
  
  .bio-text {
    text-align: center;
  }
}

/* 添加Markdown样式 */
.markdown-body {
  font-family: 'Roboto', sans-serif;
  line-height: 1.6;
  word-wrap: break-word;
}

.markdown-body p {
  margin-bottom: 16px;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3,
.markdown-body h4,
.markdown-body h5,
.markdown-body h6 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 500;
  line-height: 1.25;
}

.markdown-body ul,
.markdown-body ol {
  padding-left: 2em;
  margin-bottom: 16px;
}

.markdown-body li {
  margin-bottom: 0.25em;
}

.markdown-body li::before {
  content: none; /* 移除之前的自定义列表样式 */
}

.markdown-body strong {
  font-weight: 500;
  color: #e0e0e0;
}

.markdown-body a {
  color: #66d9ff;
  text-decoration: none;
}

.markdown-body a:hover {
  text-decoration: underline;
}

.markdown-body code {
  padding: 0.2em 0.4em;
  margin: 0;
  font-size: 85%;
  background-color: rgba(110, 118, 129, 0.4);
  border-radius: 6px;
}

/* 访问计数器样式 */
.counter-section {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  width: 100%;
}

.counter-section img {
  max-width: 100%;
}

/* 页脚样式 */
.profile-footer {
  margin-top: 40px;
  padding-top: 15px;
  text-align: center;
  font-size: 0.85rem;
  color: #888;
}

.footer-line {
  height: 1px;
  background: linear-gradient(to right, transparent, #333, #333, transparent);
  margin-bottom: 15px;
}

.copyright {
  margin-bottom: 5px;
}

.slogan {
  font-style: italic;
  color: #777;
}

/* 响应式调整 */
@media (max-width: 768px) {
  /* ...existing code... */
  
  .profile-footer {
    margin-top: 30px;
    font-size: 0.8rem;
  }
}
</style>
